import { h, Fragment, createContext } from 'preact';
import { useState, useEffect } from 'preact/hooks';
import TouchSwipe from './touch-swipe';

export const Control2 = createContext();

export const menu = function(p) {
  const [show, setShow] = useState(false);
  const [ctl2, setCtl2] = useState(null);
  useEffect(createStyle);
  useEffect(() => {
    const ts = new TouchSwipe({
      tolerance: 20,
      delta: 50,
      velocity: 0.3,
      onright: e => setShow(x => !x),
      onleft: e => setShow(false),
    });
    ts.on();
    return ts.off.bind(this);
  }, []);
  return h(Fragment, null,
    h(Control2.Provider, { value: { ctl2, setCtl2 } },
      h('div', {
        class: 'pre-menu' + (show ? ' show' : ''),
        style: { position: 'fixed' },
      },
      h('div', { class: 'pre-menu-btn', onClick: e => setShow(!show) },
        '\u2020', show ? ' hide' : ''),
      h('div', { class: 'pre-menu-contents' }, p.children),
      ),
      ctl2,
    ),
  );
};
const menuStyle = `
  .night .pre-menu {
    background-color: #555;
  }
  .pre-menu {
    font-size: 1em;
    position: fixed;
    overflow:hidden;
    top:0; left:0;
    background-color: #ddd;
    border: 1px solid;
    padding: 1px;
    border-radius: 0 5px 5px 0;
    opacity:0.3;
  }
  .pre-menu .pre-menu-contents {
    display: none;
  }
  .pre-menu .pre-menu-btn {
    cursor: pointer;
    padding: 0.25em 0.5em;
  }
  .pre-menu.show {
    max-height:90vh;
    max-width:75vw;
    opacity: 1;
    border: 3px solid;
    padding: 3px;
  }
  
  .pre-menu.show, .pre-menu.show .pre-menu-contents {
    display:flex;
    flex-direction:column;
  }
  .pre-menu.show>*, .pre-menu-contents>* {
    flex:1 1 auto;
  }
  .pre-menu.show>*:last-child, .pre-menu-contents>*:last-child {
    min-height: 1em;
  }
  .ctl-group { 
    display:flex;
    flex-wrap:wrap;
  }

  .pre-menu button {
    /* margin: 0.5em;    padding: 0.5em 1em; */
    margin: 0.3em;
    padding: 0.2em 0.5em;
    font-size: 0.8em;
  }
  .pre-menu .pre-nav-list {
    overflow-y:auto;
    padding:0 1em;
    margin:0;
  }
  .pre-menu .pre-nav-list > * {
    white-space: nowrap;
  }

  .pre-menu2 {
    cursor: pointer;
    font-size: 1em;
    position: fixed;
    overflow:hidden;
    top:0; right:0;
    background-color: #222;
    border: 1px solid;
    padding: 1px;
    border-radius: 5px 0 0 5px;
    opacity:0.3;
  }
  .op1 { opacity:0.1; }
`;
function createStyle() {
  let ss = document.head.querySelector('style#preact-menu');
  if (!ss) {
    ss = document.createElement('style');
    ss.id = 'preact-menu';
    ss.innerHTML = menuStyle;
    document.head.append(ss);
  }
}
